<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M756 1087 c-3 -13 -20 -30 -38 -39 l-33 -15 33 -17 c18 -9 37 -28 42
-41 13 -33 23 -31 37 5 7 18 21 32 37 36 34 8 33 15 -5 37 -17 9 -33 26 -36
37 -7 27 -30 25 -37 -3z m33 -64 c-15 -17 -32 -2 -23 21 5 13 9 14 20 5 11 -9
12 -15 3 -26z"
      />
      <path
        d="M137 1083 c-4 -3 -7 -94 -7 -202 0 -108 -5 -212 -10 -231 -17 -58
-23 -239 -11 -325 20 -139 46 -129 63 26 9 84 9 126 -2 210 -7 57 -15 148 -17
201 -5 122 8 147 75 148 57 0 53 18 -5 23 l-48 3 48 2 c26 1 47 6 47 11 0 6
-21 12 -47 14 l-48 3 48 2 c26 1 47 7 47 12 0 6 -21 11 -47 12 l-48 1 45 6
c33 4 45 11 46 24 1 13 -7 17 -40 19 -40 1 -40 1 -6 5 55 7 61 23 8 23 -26 0
-50 5 -53 10 -7 11 -28 13 -38 3z m96 -60 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12
5 17 0 24 -2 18 -5z m-83 -668 c-7 -58 -7 -56 -8 35 0 70 2 86 8 60 5 -19 5
-61 0 -95z"
      />
      <path
        d="M1004 1006 c-3 -7 -4 -35 -2 -62 3 -46 5 -49 32 -52 18 -2 32 2 37
11 10 16 69 11 69 -7 0 -6 -15 -60 -32 -121 -30 -103 -32 -122 -36 -295 -1
-102 0 -195 2 -206 5 -18 16 -23 62 -29 92 -11 92 -14 52 230 l-34 208 18 110
c12 73 23 113 34 121 10 8 14 23 12 46 l-3 35 -70 1 c-41 1 -71 6 -73 13 -5
16 -62 14 -68 -3z m196 -37 c0 -18 -5 -20 -47 -17 -36 2 -49 7 -51 21 -3 14 4
17 47 17 45 0 51 -3 51 -21z m-75 -505 c0 -170 -2 -199 -15 -199 -13 0 -15 29
-18 190 -3 197 0 219 21 212 9 -3 12 -52 12 -203z"
      />
      <path
        d="M369 933 c-11 -13 -11 -15 -1 -9 8 5 26 12 40 16 l27 8 -26 1 c-15 1
-33 -7 -40 -16z"
      />
      <path
        d="M385 901 c-51 -31 -68 -58 -73 -114 -2 -29 1 -80 8 -112 11 -55 13
-57 25 -36 12 23 12 23 31 -15 12 -25 32 -45 57 -57 20 -10 37 -22 37 -25 0
-4 -18 -14 -39 -23 l-39 -17 4 -118 c6 -150 9 -162 39 -176 19 -9 29 -7 49 6
37 23 48 51 56 135 7 64 12 78 34 98 29 25 83 31 117 13 30 -16 49 -64 49
-122 0 -82 51 -149 101 -133 29 9 39 45 39 138 0 87 12 140 54 249 33 87 48
177 35 221 -12 46 -64 95 -107 103 -21 4 -64 0 -106 -10 -88 -20 -158 -21
-222 -1 -66 20 -113 19 -149 -4z m155 -26 c70 -19 131 -19 203 0 112 29 165
12 193 -62 16 -41 16 -48 -3 -121 -11 -42 -33 -111 -48 -152 -20 -56 -29 -100
-32 -175 -6 -115 -15 -140 -42 -126 -24 13 -38 53 -45 126 -4 54 -9 64 -45 98
-49 45 -99 50 -152 14 -44 -30 -59 -60 -59 -125 0 -29 -7 -66 -15 -81 -15 -30
-43 -47 -56 -34 -4 4 -9 61 -10 127 -4 128 -8 117 49 145 32 16 21 54 -23 77
-29 14 -43 30 -51 55 -6 19 -22 39 -35 46 -50 25 -42 132 12 177 36 30 77 33
159 11z"
      />
      <path
        d="M332 567 l-22 -23 25 -24 25 -23 24 22 24 22 -25 25 c-13 13 -25 24
-27 24 -1 0 -12 -10 -24 -23z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
